import { render, staticRenderFns } from "./SoilMapDetails.vue?vue&type=template&id=839f2a1c&scoped=true&"
import script from "./SoilMapDetails.vue?vue&type=script&lang=js&"
export * from "./SoilMapDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoilMapDetails.vue?vue&type=style&index=0&id=839f2a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839f2a1c",
  null
  
)

export default component.exports